import { CheckboxGroupWUT } from '@wix/form-fields/viewer-wut';

export default CheckboxGroupWUT;
